import React, { useState, useEffect } from 'react';
import InputPlaneacion from './ImputPlaneacion';
import { dateFormatConDiaYHoraShort } from '../../../../../utils/DateFunctions';
import Ajustadores from './Ajustadores';

const ListaPlanesAsociados = (p) => {
    const colSpan = p.colSpan ?? 15;
    const original_data = p.data;
    const [data, setdata] = useState(p.data);
    const campos_plan = p.campos_plan;
    const mainIndex = p.index;
    const valvulas = p.valvulas ?? [];
    const ajustador = new Ajustadores();
    useEffect(() => {
        setdata(p.data);
    }, [p.data]);

    const updatePlan = (event, index) => {
        let { name, value } = event.target;
        let newData = [...data.planes];
        newData[index] = { ...newData[index], [name]: value }; // Crear una copia del objeto antes de modificarlo
        if (name === 'valvula') {
            newData[index].cama_inicio = newData[index].cama_fin = null;
            newData[index].metros_inicio = newData[index].metros_fin = 0;
            newData[index].tunel = "";
        }
        setdata({ ...data, ['planes']: newData });
        //modificaciones(newData, true);
    }

    const hayCambios = (index) => {
        let original = original_data.planes[index];
        let actual = data.planes[index];
        let cambios = 0;
        for (const key in actual) {
            if (actual.hasOwnProperty(key)) {
                if (actual[key] !== original[key]) {
                    cambios++;
                }
            }
        }
        return cambios > 0;
    }

    const actualizar = (registro) => {
        let updateData = {
            "id": registro.id,
            "plan_cosecha_id": registro.plan_cosecha_id,
            "semana_transplante": registro.semana_transplante,
            "dia_transplante": registro.dia_trasplante,
            "semana_cosecha": registro.semana_cosecha,
            "dia_cosecha": registro.dia_cosecha,
            "valvula": registro.valvula,
            "tunel": registro.tunel,
            "cama_inicio": registro.cama_inicio,
            "cama_fin": registro.cama_fin,
            "plantas_plan": registro.plantas_plan,
            "metros_inicio": registro.metros_inicio,
            "metros_fin": registro.metros_fin,
            "origen": registro.origen,
        }
        p.actualizarPlanes([updateData]);
    }

    return (
        <tr>
            <td colSpan={colSpan} className='ps-2 pe-2 pb-4 pt-0 bg-dark overflow' style={{ position: "relative" }}>
                <div className='row justify-content-evenly w-100 m-0 p-2 bg-white round-bottom-m'>
                    <div className='w-100 p-1 m-0 h4 text-300 text-center'>Planes de campo agregados</div>
                    <div className='bw-300 border-bottom border-warning m-0 p-0'></div>
                    <div className='w-100 mb-3'></div>

                    {
                        data.planes.map((reg, index) =>
                            <div className='w-100 round-s shadow p-1 shadow m-0 pt-2 mb-2 border border-2' key={'row' + index}>
                                <div className='row justify-content-evenly w-100 m-0 p-0'>
                                    <div className='bw-300'><span className='text-bold text-xs'>Modificado:</span> {dateFormatConDiaYHoraShort(reg.fecha_edicion)}</div>
                                    <div className='bw-300'><span className='text-bold text-xs'>Modificado por:</span> {reg.usuario}</div>
                                    <div className='w-100 mb-2'></div>
                                    <div className='bw-150 contenedor'>
                                        {reg.inventariado === 0 && <button className='w-100 btn btn-sm btn-dark round-s shadow text-bold'
                                            onClick={() => p.agregarAInventario(reg.id, reg.origen)}>Inventariar</button>}
                                        {reg.inventariado === 1 && reg.puede_des_inventariar === 1 &&
                                            <button className='w-100 btn btn-sm btn-light border border-warning border-2 w-100 round-s shadow text-bold'
                                                onClick={() => { p.deshacerInvetario(reg.id) }}>Deshacer inventariado</button>
                                        }
                                        {reg.puede_des_inventariar !== 1 && reg.inventariado === 1 && <span className='w-100 text-center opacity-70 text-bold'>Inventariado</span>}
                                    </div>
                                    {campos_plan.map((key, i) => <div key={index + ' input ' + i} className={`bw-100`}>
                                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                                            <div className='w-100 text-s text-bold text-satart'>{key.fancyName}</div>
                                            <InputPlaneacion
                                                input={key.input} options={key.options}
                                                name={key.key}
                                                typeInput={key.type}
                                                value={reg[key.key]}
                                                className={key.key == 'valvula' ? 'form-control form-control-sm m-0 w-70' : 'form-control form-control-sm m-0'}
                                                funcion={(e) => updatePlan(e, index)} />
                                        </div>
                                    </div>)}
                                    <div className={`bw-200`}>
                                        <div className='row justify-content-evenly w-100 m-0 p-0'>
                                            <div className='w-100 text-s text-bold text-satart'>VALVULA</div>
                                            <InputPlaneacion
                                                input={false} options={ajustador.filtrarValvulasPorRancho(reg.rancho, [...valvulas])} name={'valvula'}
                                                typeInput={""} value={reg.valvula}
                                                className={'form-control form-control-sm m-0 w-70'}
                                                funcion={(e) => updatePlan(e, index)}
                                            />

                                            <div className={'w-20 round-s shadow text-center  text-bold text-l ' + ([undefined, null, ""].includes(reg.valvula) ? ' bg-light opacity-50' : ' bg-warning pointer scale-05')}
                                                onClick={() => p.abrirDetallesDeCamasValvulas(reg, 'valvula', 'actulizacion', mainIndex, index, reg.id)}>i</div>

                                        </div>
                                    </div>
                                    <div className='bw-100'>
                                        <div className='w-100 text-bold ps-2'>CAMAS</div>
                                        <div className='w-100 text-center contenedor bg-black5 round-s pt-1 pb-1'>{reg.cama_inicio ?? 0} - {reg.cama_fin ?? 0}</div>
                                    </div>
                                    <div className='bw-150 contenedor'>
                                        <button className='w-100 btn btn-sm btn-warning w-100 round-s shadow text-bold'
                                            disabled={!hayCambios(index) && !reg.actualizar}
                                            onClick={() => { actualizar(reg) }}>
                                            Actualizar
                                        </button>

                                    </div>
                                </div>
                                <div className='bw-200 me-3 mt-2 p-0' style={{ position: "absolute", top: 0, right: 0 }}>
                                    <button className='btn btn-sm btn-danger shadow-sm p-0 w-100 text-bold round-xxl' onClick={() => { if (p.cerrar) p.cerrar() }}>Cerrar</button>
                                </div>
                            </div>
                        )
                    }

                </div>
            </td>
        </tr>
    )
}

export default ListaPlanesAsociados;